// extracted by mini-css-extract-plugin
module.exports = {"MealSurvey":"MealSurvey_MealSurvey__Fj-Wj","Overlay":"MealSurvey_Overlay__1zGhq"};